import { IWindowContainer } from "../interfaces/user.interface";
import { AssessmentService } from "../../features/participant-experience/assessments/services/assessment.service";
import { ApiBus } from "../services/api.bus";
import 'bootstrap/dist/js/bootstrap.min';
import { IGlobal } from "config/config.interface";
import { IAppTranslations } from "lib/translations/interfaces/translations.interface";

export default function BindServices(store: any) {
    loadCultures();
    const globalWindow = (window as any as IWindowContainer);
    (window as any).store = store;
    (window as any).config.toastr = (window as any).toastr;
    (window as any).config.bootstrap = (window as any).bootstrap;

    globalWindow.getApiBus = () => {
        if (globalWindow.apiBus) {
            return globalWindow.apiBus;
        } else {
            globalWindow.apiBus = new ApiBus();
        }
        return globalWindow.apiBus;
    }

    globalWindow.getAssessmentService = (translations: IAppTranslations) => {
        if (globalWindow.assessmentService) {
            return globalWindow.assessmentService;
        } else {
            globalWindow.assessmentService = new AssessmentService(translations);
        }
        return globalWindow.assessmentService;
    }
}

export const loadCultures = () => {
    (window as any).cultures = {};
    const languages = (global as any as IGlobal).config.LANGUAGES;
    languages.forEach(language => {
        (window as any).cultures[language.code] = require(`../../assets/translations/${language.code}.culture.json`);
    })
}

